document.addEventListener('alpine:init', () => {
  Alpine.data('text', () => ({
    init() {
      this.$nextTick(() => {
        this.$el.querySelectorAll('h1, h2, h3, h4, h5, h6, p').forEach((el) => {
          let match;
          let index = 0;

          while ((match = /\*(.*?\|.*?)\*/g.exec(el.innerHTML)) !== null) {
            const words = match[1].split('|').map((word) => word.trim());
            el.innerHTML = el.innerHTML.replace(
              match[0],
              `<span data-wd-index="${index}" data-wd-words="${words.join('|')}">${words[0]}</span>`
            );
            index++;
          }

          setTimeout(() => {
            for (let i = 0; i < index; i++) {
              const span = el.querySelector(`span[data-wd-index="${i}"]`);
              const words = span.dataset.wdWords.split('|');

              writeAndDelete(span, words, {
                timeout: 1500,
                loop: true,
                speed: 100,
                errorQuota: 0,
                cursor: '|',
                cursorSpeed: 500,
              });
            }
          });
        });
      });
    },
  }));
});